import dayjs from '@/js/libs/dayjs/index.ts';
import { isEqualDateRange } from './helpers.js';
// Every boundary below is the UTC start of its calendar day. The picker renders a date from its UTC
// components while the filters serialize it in local time, so only a UTC midnight reads as the same
// day both ways — an end-of-day instant displays one day earlier than it queries.
const todayDate = dayjs.utc(dayjs().format('YYYY-MM-DD'));
// isoWeek rather than startOf('week'), which follows the dayjs locale: the app sets weekStart only in
// an effect, long after this module is evaluated.
const lastWeek = [
    dayjs(todayDate).subtract(1, 'week').startOf('isoWeek').toDate(),
    dayjs(todayDate).subtract(1, 'week').endOf('isoWeek').startOf('day').toDate(),
];
const last30Days = [dayjs(todayDate).subtract(30, 'day').toDate(), dayjs(todayDate).toDate()];
const lastMonth = [
    dayjs(todayDate).subtract(1, 'month').startOf('month').toDate(),
    dayjs(todayDate).subtract(1, 'month').endOf('month').startOf('day').toDate(),
];
export const rangePresets = [
    {
        title: 'Last week',
        dateRange: lastWeek,
        dataTestId: 'last-week-preset',
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, lastWeek);
        },
    },
    {
        title: 'Last 30 days',
        dateRange: last30Days,
        dataTestId: 'last-30-days-preset',
        default: true,
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, last30Days);
        },
    },
    {
        title: 'Last month',
        dateRange: lastMonth,
        dataTestId: 'last-month-preset',
        isActive(selected) {
            return !!selected && isEqualDateRange(selected, lastMonth);
        },
    },
];
